(function () {
   'use strict';



// NOTE:
// 1. Currently the fonts are commented out; There MAY be cases where you want the font-styles to be embedded
// in that case we should configure webpack to produce two outputs (one package with fonts, one without)
// require('./styles/fonts.less');
//
// 2. Styles are commented out currently, as they are only needed for the demo page (currently)
// require('./styles/main.less');


   // INITIALIZERS
   var videos = require('./VideoPlayer/initializers.js');
   var audio = require('./AudioPlayer/initializers.js');
   var images = require('./helpers/imageInitializers.js');

   module.exports = {
     AssetCoreClient: require('./AssetCore/client.js'),
     Overlay: require('./Overlay/main.js'),
     jq3: require('jquery'),

     imagesLoaded: require('imagesloaded'),
     imagesLoadedOrDimSet: require('./helpers/ImagesLoadedOrDimensionsSet.js'),
     settings: require("./helpers/settings.js"),

     imageFromData: images.imageFromData,
     bgImageFromData: images.bgImageFromData,
     audioFromData: audio.fromData,
     videoFromData: videos.videoFromData,
     videoWithOverlay: videos.videoWithOverlay,
     smartmovieFromUrl: videos.smartmovieFromUrl
   };

}());



//////////////////
// WEBPACK FOOTER
// ./src/frontend.js
// module id = 0
// module chunks = 0